export interface ChartOption {
  id: string;
  name: string;
  description?: string;
  category: 'irrigation' | 'soil' | 'weather' | 'plant' | 'analysis';
}

export interface BiweeklyReport {
  id: string;
  sectorId: string;
  startDate: string;
  endDate: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  selectedCharts?: string[];
  technicalComment?: string;
  technicalAdministrationComment?: string;
  operationComment?: string;
}

export const AVAILABLE_CHARTS: ChartOption[] = [
  {
    id: 'irrigation',
    name: 'Kc y mm',
    description: 'Gráfico de riego y coeficiente de cultivo',
    category: 'irrigation',
  },
  {
    id: 'stackedSoilMoisture',
    name: 'Humedad de suelo',
    description: 'Humedad del suelo apilada',
    category: 'soil',
  },
  {
    id: 'soilMoisture',
    name: 'Sumatoria humedad de suelo',
    description: 'Suma de humedad del suelo',
    category: 'soil',
  },
  {
    id: 'roots',
    name: 'Profundidad riego y raíces',
    description: 'Profundidad de riego y desarrollo radicular',
    category: 'soil',
  },
  {
    id: 'plants',
    name: 'Dendrómetro de brote',
    description: 'Medición del crecimiento de brotes',
    category: 'plant',
  },
  {
    id: 'rainfall',
    name: 'Precipitaciones',
    description: 'Datos de lluvia y precipitación',
    category: 'weather',
  },
  {
    id: 'humidityTemperature',
    name: 'Humedad y Temperatura',
    description: 'Condiciones ambientales',
    category: 'weather',
  },
  {
    id: 'salinity',
    name: 'Salinidad',
    description: 'Niveles de salinidad del suelo',
    category: 'soil',
  },
  {
    id: 'soilTemperature',
    name: 'Temperatura del suelo',
    description: 'Temperatura a diferentes profundidades',
    category: 'soil',
  },
  {
    id: 'coldHours',
    name: 'Horas frío',
    description: 'Acumulación de horas de frío',
    category: 'analysis',
  },
  {
    id: 'degreeDay',
    name: 'Grados día',
    description: 'Acumulación de grados día',
    category: 'analysis',
  },
];

export const CATEGORY_COLORS = {
  irrigation: '#2196F3',
  soil: '#8BC34A',
  weather: '#FF9800',
  plant: '#4CAF50',
  analysis: '#9C27B0',
};

export const CATEGORY_NAMES = {
  irrigation: 'Riego',
  soil: 'Suelo',
  weather: 'Clima',
  plant: 'Planta',
  analysis: 'Análisis',
};
